import React, { Children, cloneElement, createContext, useContext, useRef } from "react";

import ToastContNotif from "@app/components/3_modules/ToastContNotif";

const ToastContext = createContext(null);

export default function ToastContainer({children}) {
    const refToast = useRef();
    
    const toast = {addToast: addToast};

    return (
        <ToastContext.Provider value={toast}>
            <ToastContNotif ref={refToast} />
            {children}
        </ToastContext.Provider>
    );
    
    function addToast(title, desc) {
        refToast.current.addToast(
            title, 
            desc
        );
    }
}


export function useToast() {
    return useContext(ToastContext);
};
